<!--文章详情-->
<template>
  <div class="article-container">
    <headerIndex/>
    <div class="user">
      <h1 class="title SourceHanSansCN">{{ details.title }}</h1>
      <div class="user-info">
        <div class="user-logo" @click="authorPage(details.bid)">
          <el-image style="width: 50px; height: 50px;border-radius: 50%;"
                    :src="details.user_avatar"/>
        </div>
        <div class="userTips">
          <div class="username SourceHanSansCN" @click="authorPage(details.bid)">{{ details.user_name }}</div>
          <div class="releaseTime">发布时间：{{ details.time }}</div>
          <div class="publishingPlatform">{{ details.identity_type_name }}</div>
        </div>
      </div>
    </div>
    <div class="article-content">
      <div class="container">
        <div class="left">
          <!-- 文章文本 -->
          <div class="rich-content">
            <div class="html-box" v-html="details.content"></div>
            <div v-if="details.photo.length>0 && details.title==''">
              <img :src="item" v-for="(item,index) in details.photo" :key="index" width="100%" class="img_detail">
            </div>
            <div class="bottom" @click="report">
              <p v-if="details.bid != userId">举报/反馈</p>
            </div>
          </div>
          <!-- 发布评论 -->
          <div class="pushComment">
            <p class="push-title SourceHanSansCN">发表评论</p>
            <el-input type="textarea" :rows="5" placeholder="" v-model="textarea"></el-input>
            <el-popover placement="top-start" width="400" v-model="toggleEmoji">
              <div class="emojiList">
                <span v-for="row in emoji" :key="row" @click="addEmoji(row)">{{ row }}</span>
              </div>
              <div class="mask" @click="toggleEmoji = false"></div>
              <i class="expression" slot="reference"></i>
            </el-popover>
            <div class="u-flex u-row-between" style="padding-top: 10px">
              <div></div>
              <el-button type="primary" round @click="pinglun" style="float: right">发表</el-button>
            </div>
          </div>
          <commentList :commentArray="commentArray" :total="total" @reply="reply" @dianzan="getCommentList" @showMore="showMore"></commentList>
          <!-- 分页 -->
          <page :total="total" class="pagination" @currentPage="changePage"></page>
        </div>
        <recomeThings/>
      </div>
    </div>
    <homefooter/>
    <report ref="report" title="举报文章问题" type="1" :article_id="details.id"/>
    <hang/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import detail from '@/defaultData/details.json'
import Hang from "@/components/Hang/Hang";
import homefooter from '@/components/footer/home_footer';
import recomeThings from "@/components/recommend/recomeThings";
import report from "@/components/media/report";
import emoji from "@/common/emoji"
import commentList from "@/components/media/commentList";
import page from "@/components/page/pages";
export default {
  name: "articleDetails",
  components: {headerIndex,Hang,homefooter,recomeThings,report,commentList,page},
  data() {
    return {
      cid: 0,
      id: 0,
      type: 1,
      details: {},
      reportShow: false,
      recommend: [], //相关文章
      textarea: "",
      commentArray: [], //评论列表
      saveArry: [], //保存的完整评论列表
      page: 1,
      total: 0,
      emoji,
      showEmoji: 'none',
      toggleEmoji: false,
    }
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCommentList();
      }
    },
  },
  methods: {
    //获取详情
    getArticleInfo() {
      articleInfo({
        id: this.$route.query.id,
      }).then((res) => {
        if (res.code == 200) {
          this.details = res.content;
          this.recommend = res.content.recommend;
        }
      });
    },
    //获取评论列表
    getCommentList() {
      commentList({
        aid: this.$route.query.id,
        pid: "",
        page: this.page,
      }).then((res) => {
        if (res.code == 200) {
          this.commentArray = res.content.data;
          this.saveArry = JSON.parse(JSON.stringify(res.content.data));
          this.total = res.content.total;
          for (let item1 of this.commentArray) {
            if (item1.reply[0]) {
              item1.reply = item1.reply.slice(0, 2);
            }
          }
        }
      })
    },
    //重新载入页面
    refresh(item) {
      /* sessionStorage.setItem("articleId", item.id);
       this.$router.replace({
         path: "/refresh",
       });*/
    },
    //打开举报页面
    report() {
      this.$refs.report.open();
    },
    // 点击评论
    pinglun() {
      let cid = JSON.parse(sessionStorage.getItem("cid"));
      if (!cid) {
        this.$message.error("请登录后操作");
      } else {
        if (this.textarea) {
          this.commentAddMethod();
        } else {
          this.$message.error("请输入内容");
        }
      }
    },
    // 网络请求 发布评论
    commentAddMethod(replyContent, replyId) {
      if (this.textarea.length > 600 || (replyContent && replyContent.length > 600)) {
        this.$message.error('字数不能超过600字')
        return
      }
      let obj = {
        aid: this.$route.query.id, //文章id
        pid: replyId || "", //上级评论id(被回复的顶级评论id)
        reply_id: "", //被@的评论表id（回复里面@某条评论时传）
        content: replyContent || this.textarea, //评论内容
      };
      /*commentAdd(obj).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message.success("评论成功！");
          this.textarea = "";
          this.getCommentList();
        }
      });*/
    },
    // 回复评论
    reply(obj) {
      this.commentAddMethod(obj.content, obj.id);
    },
    // 点击评论区的 展示更多
    showMore(obj) {
      this.commentArray[obj.index].reply = this.saveArry[obj.index].reply;
    },
    /*查看用户信息*/
    authorPage(bid){
      let routeData = this.$router.resolve({
        name: "userInfo",
        query:{bid:bid},
        params:{cid:this.cid},
        path: '/userInfo/index',
      });
      window.open(routeData.href, '_blank')
    },
    // 点击切换页码
    changePage(val) {
      this.page = val;
    },
    //在文章后面添加emoji表情
    addEmoji(emoji) {
      setTimeout(() => {
        this.textarea=this.textarea+emoji;
        this.toggleEmoji=false;
      }, 100);
    },
  },
  computed: {
    userId() {
      let a = JSON.parse(sessionStorage.getItem('cid'))
      if (a) return a.cid
      else return -1
    }
  },
  mounted() {
    this.getArticleInfo();
    this.getCommentList();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.cid = this.$route.params.cid;
    this.details = detail[0];
  }
}
</script>

<style scoped lang="scss">
.article-container {
  background: #F1F1F1;
  .user {
    padding: 0 18%;

    .title {
      font-size: 36px;
      font-weight: bold;
      color: #333333;
      padding-top: 60px;
      margin-block-start: 0px;
      margin-block-end: 0px;
    }

    .user-info {
      min-height: 90px;

      .user-logo {
        width: 38pt;
        height: 38pt;
        float: left;
        margin-top: 20px;
      }

      .userTips {
        float: left;
        padding-left: 10pt;
        margin-top: 20px;

        .username {
          font-size: 18px;
          font-weight: 600;
          color: #555555;
        }

        .releaseTime {
          float: left;
          font-size: 14px;
          padding-top: 5pt;
        }

        .publishingPlatform {
          float: left;
          font-size: 14px;
          margin-left: 10pt;
          padding-top: 5pt;
        }
      }
    }
  }
  .article-content {
    min-height: 100vh;
    background-color: #fff;
    padding-bottom: 30px;
    .container {
      width: 1200px;
      margin: auto;
      display: flex;
      align-items: flex-start;
      .left {
        width: 100%;
        box-sizing: border-box;
        padding-right: 2%;
        padding-top: 40px;
        margin-right: 2%;
        border-right: 1px solid #DDDDDD;
        .rich-content {
          position: relative;
          padding-bottom: 60px;
          border-bottom: 1px solid #ddd;
          .html-box{
            padding-bottom: 20px;
          }
          &::after {
            position: absolute;
            content: "";
            width: 3%;
            display: block;
            height: 1px;
            background: #ddd;
            right: -3%;
            bottom: -1px;
          }
          .bottom {
            position: absolute;
            right: 0;
            bottom: 20px;
            font-size: 16px;
            cursor: pointer;
          }
        }
      }
      .relation {
        flex: 1;
        padding-top: 40px;
        position: sticky;
        top: 0;
        .title {
          font-size: 22px;
          font-weight: bold;
          padding-bottom: 20px;
        }
        .item {
          margin-bottom: 40px;
          cursor: pointer;
          .name {
            font-size: 16px;
            font-weight: bold;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .pushComment {
    .push-title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
  .author {
    &:hover {
      color: #fe273b;
    }
  }
  .chat_total {
    font-size: 22px;
    font-family: 'SourceHanSansCN';
    font-weight: 100;
    color: #333333;
  }
}
</style>
<style scoped>
.html-box >>> img {
  max-width: 100% !important;
  margin: 20px 0;
}

.html-box >>> p {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
}

.pushComment >>> .el-textarea__inner {
  background-color: #F1F1F1;
  resize: none;
  border-radius: 12px;
  font-size: 16px;
  color: #333333;
}
.pagination >>> .titel {
  display: none;
}
.img_detail {
  margin-top: 10px;
}
.pushComment >>> .el-button--primary {
  color: #FFF;
  background-color: #0067DD;
  border-color: #0067DD;
}
.emojiList {
  width: 520px;
  height: 300px;
  overflow: auto;
  background-color: white;
  text-align: justify;
  align-items: center;
  flex-wrap: wrap;
  z-index: 9999;
  padding: 0 10px 10px 0px;
}

.emojiList >>> span {
  font-size: 20px;
  cursor: pointer;
  width: 58px;
  margin: 10px 5px;
}
.expression{
  background: url("~@/assets/img/biaoqing.png") no-repeat;
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  float: left;
  margin-top: 15px;
}
</style>